export default "__VITE_ASSET__CPSyj_qH__"